import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { UIText2, CheckboxButton, Button, UIHeading4 } from '@cian/ui-kit';
import { Datepicker } from '../Datepicker/desktop';
import * as styles from './styles.css';
import { getCalendarDay } from '../../utils/getCalendarDay';
import { getAvailableTimeSlots } from '../../utils/getAvailableTimeSlots';
import { getDate } from '../../utils/getDate';
import { formatDateLabel } from '../../utils/formatters';
import { IE_USER_AGENT } from '../../constants/userAgent';
import { TIME_SEPARATOR } from '../../constants/dateTime';
import { NameInput, PhoneInput } from '../Inputs/desktop';
import { validateName } from '../../utils/name';
import { validatePhone } from '../../utils/phone';
import { Link } from '../Link/desktop';
import { DisclaimerField } from '../DisclaimerField';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NEXT_DAY_BTN_INDEX = 1;
var NEXT_NEXT_DAY_BTN_INDEX = 2;
var OTHER_DATE_BTN_INDEX = 3;
export function DesktopForm(_ref) {
  var onSubmit = _ref.onSubmit,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    disabledDays = _ref.disabledDays,
    nextDate = _ref.nextDate,
    nextNextDate = _ref.nextNextDate,
    availableDates = _ref.availableDates,
    privacyPolicyUrl = _ref.privacyPolicyUrl,
    marketingAgreementUrl = _ref.marketingAgreementUrl,
    personalDataAgreementUrl = _ref.personalDataAgreementUrl,
    isMarketingAgreementEnabled = _ref.isMarketingAgreementEnabled;
  var nextDay = React.useMemo(function () {
    return getCalendarDay(nextDate);
  }, [nextDate]);
  var nextNextDay = React.useMemo(function () {
    return getCalendarDay(nextNextDate);
  }, [nextNextDate]);
  var minDay = React.useMemo(function () {
    return getCalendarDay(minDate);
  }, [minDate]);
  var maxDay = React.useMemo(function () {
    return getCalendarDay(maxDate);
  }, [maxDate]);
  var _React$useState = React.useState(NEXT_DAY_BTN_INDEX),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    checkedBtn = _React$useState2[0],
    setCheckedBtn = _React$useState2[1];
  var _React$useState3 = React.useState(nextDay),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    selectedDate = _React$useState4[0],
    setSelectedDate = _React$useState4[1];
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    selectedTime = _React$useState6[0],
    setSelectedTime = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isCalendarOpen = _React$useState8[0],
    setCalendarOpen = _React$useState8[1];
  var _React$useState9 = React.useState(''),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    name = _React$useState10[0],
    setName = _React$useState10[1];
  var _React$useState11 = React.useState(''),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    phone = _React$useState12[0],
    setPhone = _React$useState12[1];
  var nextDayText = React.useMemo(function () {
    return formatDateLabel(nextDay);
  }, [nextDay]);
  var nextNextDayText = React.useMemo(function () {
    return formatDateLabel(nextNextDay);
  }, [nextNextDay]);
  var isIE = IE_USER_AGENT.test(window.navigator.userAgent);
  var selectedDateString = getDate(selectedDate).toDateString();
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    checked = _React$useState14[0],
    setChecked = _React$useState14[1];
  var timeSlots = React.useMemo(function () {
    return getAvailableTimeSlots(selectedDate, availableDates);
  }, [selectedDateString]);
  var disabled = selectedDate === null || selectedTime === null || !timeSlots.includes(selectedTime) || !validateName(name) || !validatePhone(phone);
  var setNextDate = function setNextDate() {
    setCheckedBtn(NEXT_DAY_BTN_INDEX);
    setSelectedDate(nextDay);
  };
  var setNextNextDate = function setNextNextDate() {
    setCheckedBtn(NEXT_NEXT_DAY_BTN_INDEX);
    setSelectedDate(nextNextDay);
  };
  var setOtherDate = function setOtherDate(date) {
    setCheckedBtn(OTHER_DATE_BTN_INDEX);
    setSelectedDate(date);
  };
  var handleSubmit = function handleSubmit() {
    if (selectedDate && selectedTime) {
      var year = selectedDate.year,
        month = selectedDate.month,
        day = selectedDate.day;
      var _selectedTime$split = selectedTime.split(TIME_SEPARATOR),
        _selectedTime$split2 = _slicedToArray(_selectedTime$split, 2),
        hours = _selectedTime$split2[0],
        minutes = _selectedTime$split2[1];
      var dateTime = new Date(year, month - 1, day, Number(hours), Number(minutes));
      onSubmit({
        dateTime: dateTime,
        name: name,
        phone: "+7".concat(phone)
      });
      setName('');
      setPhone('');
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    onClick: function onClick() {
      return setCalendarOpen(false);
    },
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles['content'],
      children: [/*#__PURE__*/_jsx(UIHeading4, {
        children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0430\u0442\u0443"
      }), /*#__PURE__*/_jsxs("div", {
        className: styles['date-btns'],
        children: [/*#__PURE__*/_jsx(CheckboxButton, {
          label: nextDayText,
          checked: checkedBtn === NEXT_DAY_BTN_INDEX,
          onClick: setNextDate,
          size: "M"
        }), /*#__PURE__*/_jsx(CheckboxButton, {
          label: nextNextDayText,
          checked: checkedBtn === NEXT_NEXT_DAY_BTN_INDEX,
          onClick: setNextNextDate,
          size: "M"
        }), !isIE && /*#__PURE__*/_jsx(Datepicker, {
          checked: checkedBtn === OTHER_DATE_BTN_INDEX,
          onSelectDate: setOtherDate,
          disabledDays: disabledDays,
          isOpen: isCalendarOpen,
          setOpen: setCalendarOpen,
          minDay: minDay,
          maxDay: maxDay
        })]
      }), /*#__PURE__*/_jsx(UIHeading4, {
        children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0440\u0435\u043C\u044F"
      }), /*#__PURE__*/_jsx("div", {
        className: styles['time-note'],
        children: /*#__PURE__*/_jsx(UIText2, {
          color: "text-secondary-default",
          children: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0443\u0434\u043E\u0431\u043D\u043E\u0435 \u0432\u0430\u043C \u0432\u0440\u0435\u043C\u044F, \u0430 \u043C\u044B\xA0\u0443\u0442\u043E\u0447\u043D\u0438\u043C \u0435\u0433\u043E \u0443\xA0\u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u0430"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles['time-btns'],
        children: timeSlots.map(function (value) {
          return /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(CheckboxButton, {
              size: "M",
              label: value,
              checked: value === selectedTime,
              onClick: function onClick() {
                return setSelectedTime(value);
              }
            })
          }, value);
        })
      }), /*#__PURE__*/_jsx(UIHeading4, {
        children: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"
      }), /*#__PURE__*/_jsx("div", {
        className: styles['description'],
        children: /*#__PURE__*/_jsx(UIText2, {
          color: "text-secondary-default",
          children: "\u041E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0441\u0432\u043E\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0434\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0434\u0430\u0442\u044B \u0438 \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles['inputs'],
        children: [/*#__PURE__*/_jsx(NameInput, {
          value: name,
          onChange: setName
        }), /*#__PURE__*/_jsx(PhoneInput, {
          value: phone,
          onChange: setPhone
        })]
      })]
    }), isMarketingAgreementEnabled && /*#__PURE__*/_jsxs("div", {
      className: styles['footer-with-disclaimer'],
      children: [/*#__PURE__*/_jsx(Button, {
        theme: "fill_primary",
        size: "L",
        disabled: disabled,
        onClick: handleSubmit,
        fullWidth: true,
        children: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F \u043D\u0430 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440"
      }), /*#__PURE__*/_jsx(DisclaimerField, {
        checked: checked,
        onChange: setChecked,
        privacyPolicyUrl: privacyPolicyUrl,
        marketingAgreementUrl: marketingAgreementUrl,
        personalDataAgreementUrl: personalDataAgreementUrl
      })]
    }), !isMarketingAgreementEnabled && /*#__PURE__*/_jsxs("div", {
      className: styles['footer'],
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs(UIText2, {
          color: "text-secondary-default",
          children: ["\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0443, \u0432\u044B \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Link, {
            url: privacyPolicyUrl,
            target: "blank",
            children: "\u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445"
          })]
        })
      }), /*#__PURE__*/_jsx(Button, {
        theme: "fill_primary",
        size: "M",
        disabled: disabled,
        onClick: handleSubmit,
        children: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C"
      })]
    })]
  });
}